module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "x-filter"
  }, [(_vm.getRootGroup()) ? _c('x-filter-group', {
    attrs: {
      "group": _vm.getRootGroup(),
      "index": 0,
      "filterDefinitions": _vm.workingFilterDefinitions
    },
    on: {
      "updateGroup": _vm.updateGroup
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ca1d42fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataInput/XFilter.vue
// module id = 1993
// module chunks = 0